import { render, staticRenderFns } from "./IconCircleQuestion.vue?vue&type=template&id=492d12ce&"
import script from "./IconCircleQuestion.vue?vue&type=script&lang=js&"
export * from "./IconCircleQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports